enum Age {
  Teens = "< 20",
  Twenties = "20-29",
  Thirties = "30-39",
  Fourties = "40-49",
  OverFifty = "50+",
}


const ageQuestion = {
  name: "age",
  description: `This helps us factor in age-related changes in your metabolism.`,
  descriptionLocation: "underTitle",
  title: `What is your age range?`,
  type: "radiogroup",
  choices: Object.values(Age),
  isRequired: true,
};

export { Age, ageQuestion };
